<template>
  <div class="mt-0 pt-2">
    <div>
      <div class="flex w-full mt-2">
        <QuarantineLevelCard
          class="w-full mr-6"
          :user="user"
          :quarantine="quarantine"
          :payout="currentPayout"
        />
      </div>
      <div>
        <div class="text-center ">
          <YButton
            class="mt-16"
            color="red"
            @click="deleteQuarantine(quarantine.id)"
            :is-loading="isDeleting"
            >Remove Quarantine</YButton
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuarantineLevelCard from '@/components/general/QuarantineLevelCard.vue'
import DELETE_QUARANTINE_MUTATION from '@/graphql/Quarantine/DeleteQuarantineMutation.gql'

export default {
  components: {
    QuarantineLevelCard
  },
  props: {
    user: {
      type: Object,
      required: false
    },
    quarantine: {
      type: Object,
      required: true
    },
    currentPayout: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isDeleting: false
    }
  },
  methods: {
    deleteQuarantine(id) {
      this.isDeleting = true
      this.$apollo
        .mutate({
          mutation: DELETE_QUARANTINE_MUTATION,
          variables: {
            id: id
          }
        })
        .then(() => {
          this.isDeleting = false
          this.$emit('deleted')
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>

<style scoped>
.inactive {
  opacity: 0.3;
}
</style>
